import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TemplateForm from '../../components/templates/TemplateForm';
import templatesService from '../../services/templatesService';
import { useNotify } from '../../context/NotificationContext';
import { useCommon } from '../../context/CommonContext';
const AddTemplate = () => {
  const navigate = useNavigate();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const { setPageTitle } = useCommon();
  useEffect(() => {
    setPageTitle("Add Template");
  }, []);
  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const res = await templatesService.createTemplate({
        name: values.name,
        description: values.description || null,
        temp_type: values.type || null,
        is_active: values.is_active ?? true,
      });
      notify.success({ message: res?.data?.message || "Template created successfully" });
      navigate('/templates');
    } catch (error) {
      console.log("error",error);
      notify.error({ message: error?.data?.message || "Failed to create template" });
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/templates');
  };

  return (
      <TemplateForm
        loading={loading}
        onSubmit={handleSubmit}
        onBack={handleBack}
        isEdit={false}
      />
  );
};

export default AddTemplate;
